import { useDroppable } from '@dnd-kit/core';
import { ZfBox } from '@zafire/react';
import type { CSSProperties, FunctionComponent, PropsWithChildren } from 'react';
import type { DroppableId } from '../../../enums';

interface IProps extends PropsWithChildren {
    droppableId: DroppableId;
    style?: CSSProperties;
}

export const Droppable: FunctionComponent<IProps> = ({ droppableId, style, children }) => {
    const { isOver, setNodeRef } = useDroppable({ id: droppableId });

    return (
        <ZfBox ref={setNodeRef} style={style} className={`dnd-list ${isOver ? 'dnd-list-destination' : ''}`}>
            {children}
        </ZfBox>
    );
};
